// 简单的事件发射器系统
class SimpleEventEmitter {
    constructor() {
        this.events = {};
    }

    // 添加事件监听器
    on(eventName, callback) {
        if (!this.events[eventName]) {
            this.events[eventName] = [];
        }
        this.events[eventName].push(callback);
    }

    // 移除事件监听器
    off(eventName, callback) {
        if (!this.events[eventName]) return;

        if (callback) {
            this.events[eventName] = this.events[eventName].filter(cb => cb !== callback);
        } else {
            delete this.events[eventName];
        }
    }

    // 添加只执行一次的事件监听器
    once(eventName, callback) {
        const onceCallback = (data) => {
            callback(data);
            this.off(eventName, onceCallback);
        };
        this.on(eventName, onceCallback);
    }

    // 发射事件
    emit(eventName, data) {
        if (!this.events[eventName]) return;

        this.events[eventName].forEach(callback => {
            try {
                callback(data);
            } catch (error) {
                console.error(`Error in event listener for ${eventName}:`, error);
            }
        });
    }

    // 移除所有监听器
    removeAllListeners(eventName) {
        if (eventName) {
            delete this.events[eventName];
        } else {
            this.events = {};
        }
    }
}

// 创建全局事件发射器实例
const globalEventEmitter = new SimpleEventEmitter();

// 导出全局实例和类
export default globalEventEmitter;
export { SimpleEventEmitter };
